import { useTranslation } from "react-i18next";

const SaveBtn = ({ onHandleClick }) => {
    const [t] = useTranslation("global");
    return (
        <button
            className="account-save-btn ocean-btn"
            onClick={() => onHandleClick()}
        >
            <span>{t("account.save")}</span>
        </button>
    );
};

export default SaveBtn;
